<template>
  <div class="invigilate" v-loading="loading">
    <div class="wrap">
      <h2>监考记录</h2>
      <el-select
        v-model="content_type"
        placeholder="请选择"
        @change="selectChange"
      >
        <el-option label="全部" value="0"> </el-option>
        <el-option label="非本人" value="1"> </el-option>
        <el-option label="使用其他窗口" value="2"> </el-option>
        <el-option label="检测不到考生" value="3"> </el-option>
        <el-option label="关闭摄像头" value="4"> </el-option>
        <el-option label="出现多人同窗" value="5"> </el-option>
      </el-select>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="姓名" align="center" prop="mem_name">
      </el-table-column>
      <el-table-column label="手机号" align="center" prop="mem_phone">
      </el-table-column>
      <el-table-column label="部门" align="center" prop="sys_class_name">
      </el-table-column>
      <!-- <el-table-column label="考试科目" align="center"> </el-table-column> -->
      <el-table-column label="违规内容" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.content_type == 1" style="color:#409eff"
            >非本人</span
          >
          <span v-if="scope.row.content_type == 2" style="color:#67c23a"
            >使用其他窗口</span
          >
          <span v-if="scope.row.content_type == 3" style="color:#e6a23c"
            >检测不到考生</span
          >
          <span v-if="scope.row.content_type == 4" style="color:#f56c6c"
            >关闭摄像头</span
          >
          <span v-if="scope.row.content_type == 5" style="color:#909399"
            >出现多人同窗</span
          >
          <!-- <span v-if="scope.row.content_type == 6" style="color:#606266"
            >离开考场</span
          > -->
        </template>
      </el-table-column>
      <el-table-column label="违规时间" align="center" prop="created_at">
      </el-table-column>
      <el-table-column label="系统拍照" align="center">
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click="imgShow(scope.row)"
            v-if="scope.row.file"
            >查看</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total">
      <div class="pages-item">
        <p class="pages-text">
          每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
        </p>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="total"
        class="pages-item"
      ></el-pagination>
    </div>
    <el-dialog title="违规记录" :visible.sync="img_show" width="500px" center>
      <img :src="file" alt="" style="width:100%" />
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "invigilate",
  data() {
    return {
      tableData: [],
      pageSize: 20,
      total: 0,
      search: "",
      page: 1,
      loading: false,
      user_id: "",
      paper_id: "",
      img_show: false,
      file: "",
      classData: [],
      content_type: "0",
    };
  },
  created() {
    let _this = this;
    _this.user_id = this.$route.query.user_id;
    _this.paper_id = this.$route.query.paper_id;
    this.classData = JSON.parse(localStorage.getItem("classData"));
    _this.init();
  },
  methods: {
    init() {
      let _this = this;
      let postData = {
        uid: _this.user_id,
        paper_id: _this.paper_id,
        page: _this.page,
        content_type: _this.content_type,
      };
      if (this.$route.query.type) {
        postData.uid = 0;
      }
      _this.$http
        .post(process.env.VUE_APP_API_URL + "admin/invigilateInfo", postData)
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data;
            _this.total = data.data.total;
            let result = data.data.result;
            _this.tableData.forEach((ele) => {
              ele.mem_name = ele.user.mem_name;
              ele.mem_phone = ele.user.mem_phone;
              if (result.class_id) {
                ele.sys_class_name = _this.classData.find(
                  (item) => item.sys_class_id == result.class_id
                ).sys_class_name;
              }
            });
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    selectChange() {
      this.init();
    },
    imgShow(row) {
      this.img_show = true;
      this.file = row.file;
    },
    handleCurrentChange(currentPage) {
      let _this = this;
      _this.page = currentPage;
      _this.init();
    },
    handleSearch() {},
  },
};
</script>

<style lang="less" scoped>
.pages {
  padding: 10px;
  background-color: #f6f9fc;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
.wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-select {
  margin-right: 30px;
}
</style>
